import React, { Component } from 'react';
import axios from 'axios';

import {
  NavLink,
  Redirect
} from 'react-router-dom';


class Create extends Component {


  constructor(props) {
    super(props);
    this.state = {
      title: '',
      body: '',
      success: '',
      error: '',
      getuuid: ''
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleEligardSubmit = this.handleEligardSubmit.bind(this);
    this.handleHippurinSubmit = this.handleHippurinSubmit.bind(this);
  }

  handleChange(event) {
  
  
    const key = event.target.name;
    const value = event.target.value;
    this.setState({
      [key]: value
    })
  }

  handleEligardSubmit(event) {
   	const timestamp = Date.now();
    event.preventDefault();
  
  	// var uid = localStorage.getItem('uid');
    var auth = localStorage.getItem('auth');
    var csrf_token = localStorage.getItem('csrf_token');
    // var username = localStorage.getItem('username');
    // var logout_token = localStorage.getItem('logout_token');
  
    var self = this;
  	
  	//console.log(uid);
  	//console.log(csrf_token);
  	//console.log(username);
  	//console.log(logout_token);

	var axiosConfig = {
  		headers: {
        'Content-Type': 'application/json',
      	'X-CSRF-Token': csrf_token,
        "Authorization":"Basic " + auth,
  		}
	};
	
  	console.log(timestamp);
	console.log(auth);
  
    axios.post('https://api.recordatifocus.com/node/?_format=json', {
      type: [{"target_id":"eligard"}],
      title: [{"value": timestamp}],
      body: [{"value": this.state.body}]
    }, axiosConfig)
    .then(function (response) {
    
      //console.log(response);
	  console.log(response.data.uuid["0"].value)
    
      self.setState({
        getuuid: response.data.uuid["0"].value,
        'success': 'Message sent getuuid',
        'error': ''
      });
    })
    .catch(function (error) {
      var errorResponse = error.response.data.message;
      errorResponse = errorResponse.replace(/(?:\r\n|\r|\n)/g, '<br />');

      self.setState({
        'success': '',
        'error': errorResponse
      });
    });
  }

  handleHippurinSubmit(event) {
   	const timestamp = Date.now();
    event.preventDefault();
  
  	// var uid = localStorage.getItem('uid');
    var auth = localStorage.getItem('auth');
    var csrf_token = localStorage.getItem('csrf_token');
    // var username = localStorage.getItem('username');
    // var logout_token = localStorage.getItem('logout_token');
  
    var self = this;
  	
  	//console.log(uid);
  	//console.log(csrf_token);
  	//console.log(username);
  	//console.log(logout_token);

	var axiosConfig = {
  		headers: {
        'Content-Type': 'application/json',
      	'X-CSRF-Token': csrf_token,
        "Authorization":"Basic " + auth,
  		}
	};
	
  	console.log(timestamp);

  
    axios.post('https://api.recordatifocus.com/node/?_format=json', {
      type: [{"target_id":"hippurin"}],
      title: [{"value": timestamp}],
      body: [{"value": this.state.body}]
    }, axiosConfig)
    .then(function (response) {
    
      //console.log(response);
	  console.log(response.data.uuid["0"].value)
    
      self.setState({
        getuuid: response.data.uuid["0"].value,
        'success': 'Message sent getuuid',
        'error': ''
      });
    })
    .catch(function (error) {
      var errorResponse = error.response.data.message;
      errorResponse = errorResponse.replace(/(?:\r\n|\r|\n)/g, '<br />');

      self.setState({
        'success': '',
        'error': errorResponse
      });
    });
  }


  render(){
    var loggedIn = localStorage.getItem('auth');
    if (loggedIn) {
        return (
          <div className="row top-buffer">
            <div className="col-lg-3">
			<div className="mb-5">
            	<div className="border mb-3 bg-white rounded-3 border-1"><img src="/images/eligard-logo.png"/></div>
              	<form className="text-center" onSubmit={this.handleEligardSubmit}>
                	<button type="submit" className="btn btn-primary w-100">Eligard Soru Olustur</button>
              	</form>
            </div>
			<div className="">
            	<div className="border mb-3 bg-white rounded-3 border-1"><img src="/images/hippurin-logo.png"/></div>
              <form className="text-center" onSubmit={this.handleHippurinSubmit}>
                <button type="submit" className="btn btn-secondary w-100">Hippurin Soru Olustur</button>
              </form>
            </div>


            </div>

                <div className="col-lg-9 text-center">
                  <p className="success d-none">{this.state.success}</p>
                  <p className="title d-none">{this.state.getuuid}</p>
                  <p className="error" dangerouslySetInnerHTML={{__html: this.state.error}} />
                  <div className="mb-4">
					{!this.state.getuuid && <div className="text-center">soru olusturunuz</div>}
                  
                  	{this.state.getuuid && <img src={`https://api.qrserver.com/v1/create-qr-code/?format=svg&data=http%3A//api.recordatifocus.com/eligard/${this.state.getuuid}&size=320x320`}/>}
                  </div>
                  <div>
                	{this.state.getuuid && <a href={`https://slide.recordatifocus.com/hippurin/${this.state.getuuid}`}>Sunum</a>}
                  </div>
                </div>



          </div>
        );
    } else {
        return (
          <div className="row top-buffer">
        	<Redirect to="/user/login" />
          </div>
        );
    }
  }
}

export default Create



// WEBPACK FOOTER //
// src/components/create.jsx